"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const ChallengeType_1 = require("../../enums/ChallengeType");
const AuthenticationFactor_1 = require("../../enums/AuthenticationFactor");
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
const ElementIds_1 = require("../../enums/ElementIds");
const SlideHeaderWithNav_vue_1 = tslib_1.__importDefault(require("../SlideHeaderWithNav.vue"));
const ContainerSlide_vue_1 = tslib_1.__importDefault(require("../ContainerSlide.vue"));
const OneTimeCodeForgot_vue_1 = tslib_1.__importDefault(require("./OneTimeCodeForgot.vue"));
const IsotopeHeader_vue_1 = tslib_1.__importDefault(require("../IsotopeHeader.vue"));
const StepUpOption_vue_1 = tslib_1.__importDefault(require("../stepup/StepUpOption.vue"));
const userTelemetry_1 = require("../../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'step-up',
    props: {},
    data: () => {
        return {
            selectedCategory: null,
            selectedDestination: null,
            isSubmitting: false,
            tokenTOTP: {
                show: false,
                valid: false,
                code: '',
            },
        };
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    computed: {
        stepUpChallenge() {
            return this.$store.state.currentChallenge;
        },
        scenarioType() {
            if (this.$store.getters.isForgotUsernameWorkflow)
                return 'ForgotUsername';
            if (this.$store.getters.isForgotPasswordWorkflow)
                return 'ForgotPassword';
            return 'Registration';
        },
        headerText() {
            let siteTextKey = !this.tokenTOTP.show ? `${this.scenarioType}.StepUp.Heading` : `${this.scenarioType}.VerificationCode.Heading`;
            return siteTextKey;
        },
        stepUpCategories() {
            const categories = this.stepUpChallenge.StepUpCategories || [];
            const displayCategories = categories
                .filter(category => category.StepUpModel.AuthenticationFactorValue !== 'Unknown');
            return displayCategories;
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        buttonDisabled() {
            if (this.isSubmitting || !this.selectedCategory)
                return true;
            if (!this.tokenTOTP.show) {
                switch (this.selectedCategory.StepUpModel.AuthenticationFactorValue) {
                    case AuthenticationFactor_1.AuthenticationFactor.Token:
                    case AuthenticationFactor_1.AuthenticationFactor.TOTP:
                        return false;
                }
                if (this.selectedDestination === null)
                    return true;
            }
            else {
                // Code to disable the continue button on the TOTP/Token screen
                return !this.tokenTOTP.valid;
            }
            return false;
        },
        buttonText() {
            var _a, _b;
            if (!this.tokenTOTP.show) {
                return (_a = this.$options.filters) === null || _a === void 0 ? void 0 : _a.sitetext('ForgotWorkflow.ActionButtonText');
            }
            return (_b = this.$options.filters) === null || _b === void 0 ? void 0 : _b.sitetext('Forgot.VerificationCode.Verify');
        },
        hasError() {
            return (this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Success &&
                this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Unknown);
        },
        isSyncing() {
            return this.$store.getters.isSyncing;
        },
        isRedirecting() {
            const authModel = this.$store.getters.authenticatedModel;
            if (!authModel || authModel.username.length === 0 || authModel.nonce.length === 0)
                return false;
            return true;
        },
        isLoading() {
            return this.isSubmitting || this.isSyncing || this.isRedirecting;
        },
        elementIds: () => ElementIds_1.ElementIds,
        buttonID() {
            if (!this.tokenTOTP.show) {
                return this.elementIds.StepUpContinue;
            }
            return this.elementIds.OTPVerify;
        },
        showManualGeneratedMFA() {
            const categories = this.$store.state.currentChallenge.StepUpCategories || [];
            const selectedCategory = categories
                .find(category => category.StepUpModel.AuthenticationFactorValue === 'Unknown');
            const manualDestination = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.StepUpModel.Destinations.find(x => x.MaskedAddress === 'Manual');
            if (manualDestination !== undefined) {
                return true;
            }
            return false;
        },
    },
    methods: {
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
        isSelectedCategory(id) {
            if (!this.selectedCategory || this.selectedCategory.$id !== id)
                return false;
            return true;
        },
        stepupCategorySelected(category) {
            this.selectedCategory = category;
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                const verificationType = category.StepUpModel.AuthenticationFactorValue.toLowerCase().replace('code', '');
                void userTelemetry_1.telemetry.custom({
                    workflowName: workflow,
                    stepType: userTelemetry_1.stepType.progression,
                    stepName: userTelemetry_1.stepName.verify_your_identity,
                    action: userTelemetry_1.userAction.verification_type_chosen,
                    eventProperties: {
                        verificationType,
                    },
                });
            }
        },
        stepupDestinationSelected(destination) {
            this.selectedDestination = destination;
        },
        async submitForm() {
            if (this.isSubmitting || !this.selectedCategory) {
                return;
            }
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                void userTelemetry_1.telemetry.custom({
                    workflowName: workflow,
                    stepType: userTelemetry_1.stepType.progression,
                    stepName: userTelemetry_1.stepName.verify_your_identity,
                    action: userTelemetry_1.userAction.continue_clicked,
                });
            }
            let challenge;
            switch (this.selectedCategory.StepUpModel.AuthenticationFactorValue) {
                case AuthenticationFactor_1.AuthenticationFactor.Token:
                case AuthenticationFactor_1.AuthenticationFactor.TOTP:
                    if (!this.tokenTOTP.show) {
                        // update steps
                        if (this.$store.getters.currentWorkflowMaxSteps > 0 &&
                            this.$store.getters.currentWorkflowStep < this.$store.getters.currentWorkflowMaxSteps) {
                            const nextStepNum = this.$store.getters.currentWorkflowStep;
                            this.$store.commit('setCurrentWorkflowStep', nextStepNum + 1);
                        }
                        // switch to show the token/totp code input
                        this.tokenTOTP.show = true;
                        // Focus the updated heading for accessibility
                        this.$refs.heading.focus();
                        return;
                    }
                    // submit the token/totp challenge
                    challenge = {
                        ...this.stepUpChallenge,
                        ValidationKey: this.tokenTOTP.code,
                        AuthenticationFactorValue: this.selectedCategory.StepUpModel.AuthenticationFactorValue,
                        ProviderId: this.selectedCategory.NextChallenge.ProviderId,
                        ChallengeTypeValue: ChallengeType_1.ChallengeType.OneTimeCode,
                    };
                    // set the state to remain on the same screen for invalid code
                    this.$store.commit('setRemainOnStepUpScreenOnFailure', true);
                    // reset the challenge status before submitting so we pick up a new one
                    this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
                    break;
                default:
                    challenge = {
                        ...this.selectedCategory.NextChallenge,
                        Destination: { ...this.selectedDestination },
                    };
                    break;
            }
            // Everything else sends to the backend to send the OTP code
            this.isSubmitting = true;
            await this.$store.dispatch('submitChallenge', challenge);
            this.isSubmitting = false;
            // reset code if there are errors
            if (this.hasError) {
                this.tokenTOTP.code = '';
            }
        },
        changeStepupMethod() {
            // Update the steps
            if (this.$store.getters.currentWorkflowMaxSteps > 0) {
                const previousStepNum = this.$store.getters.currentWorkflowStep - 1;
                this.$store.commit('setCurrentWorkflowStep', previousStepNum);
            }
            // Switching back from TOTP/Token input to method selection
            this.tokenTOTP = {
                show: false,
                valid: false,
                code: '',
            };
            // Focus the heading for accessibility
            this.$refs.heading.focus();
        },
        otpCodeEntered({ valid, code }) {
            this.tokenTOTP.valid = valid;
            this.tokenTOTP.code = code;
        },
        async submitManualMfa() {
            if (this.isSubmitting) {
                return;
            }
            this.isSubmitting = true;
            const categories = this.$store.state.currentChallenge.StepUpCategories || [];
            const selectedCategory = categories
                .find(category => category.StepUpModel.AuthenticationFactorValue === 'Unknown');
            const challenge = {
                ...selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.NextChallenge,
                Destination: { ...selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.StepUpModel.Destinations.find(x => x.MaskedAddress === 'Manual') },
            };
            await this.$store
                .dispatch('submitChallenge', {
                ...challenge,
                Destination: { ...selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.StepUpModel.Destinations.find(x => x.MaskedAddress === 'Manual') },
            });
            this.isSubmitting = false;
        },
    },
    components: {
        SlideHeaderWithNav: SlideHeaderWithNav_vue_1.default,
        ContainerSlide: ContainerSlide_vue_1.default,
        StepUpOption: StepUpOption_vue_1.default,
        OneTimeCode: OneTimeCodeForgot_vue_1.default,
        IsotopeHeader: IsotopeHeader_vue_1.default,
    },
});
